<template lang="">
<div class="wrap-kiosk wedding type4">
    <div class="wrap--inner">
        <div class="name--wrap">
            <div>{{ weddingInfo.groomName }}</div>
            <span class="and">and</span>
            <div>{{ weddingInfo.brideName }}</div>
        </div>
        <div class="comment--wrap">
            <div class="swiper commentSwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="payment in paymentList">
                        <div v-html="payment.message"></div>
                        <p>{{ payment.sender }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="photo--wrap">
            <div class="swiper photoSwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="slide in weddingInfo.attachList">
                        <img :src="$getImgUrl(slide)" alt ="웨딩사진" />
                    </div>
                </div>
            </div>
        </div>
        <div class="guest--wrap">
            <ul>
                <li v-for="payment in paymentList">{{ payment.name }}</li>
            </ul>
        </div>
        <div class="qr--wrap">
            <canvas ref="qrcanvas"></canvas>
        </div>
    </div>
</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import QRCode from 'qrcode';
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import '@/assets/kiosk/css/common.css';

const paymentModule = 'paymentModule'

export default {
    props: {
        weddingInfo: {
            type: Object,
            required: true
        },
        invitationSeq: {
            type: Number,
            required: true
        }
    },

    data () {
        return {
            page: this.$route.query.page,
            currentIndex: 0,
            updateInterval: null,
            qrUrl: '',
            commentSwiper: null,
            photoSwiper: null
        }
    },

    methods: {
        ...mapActions(paymentModule, ["requestPaymentListForKiosk"]),

        async fetchData() {
            try {
                const { invitationSeq, page } = this;
                await this.requestPaymentListForKiosk({ invitationSeq, page });
            } catch (error) {
                console.error("데이터 갱신 오류:", error);
            }
        },

        async generateQRCode() {
            try {
                const currentUrl = window.location.href
                let newUrl = currentUrl.replace('/kiosk/', '/').split('?')[0]

                const canvas = this.$refs.qrcanvas
                if (canvas) {
                    await QRCode.toCanvas(canvas, newUrl, {
                        width: canvas.offsetWidth,
                        margin: 0
                    });

                    // canvas.style.width = '';
                    // canvas.style.height = '';
                }
            } catch (err) {
                console.error('QR 생성 실패:', err)
            }
        },

        initSwiper() {
            if (this.commentSwiper) {
                this.commentSwiper.destroy(true, true);
                this.commentSwiper = null;
            }

            if (this.photoSwiper) {
                this.photoSwiper.destroy(true, true);
                this.photoSwiper = null;
            }

            // if (this.paymentList && this.paymentList.length > 0) {
                this.commentSwiper = new Swiper('.commentSwiper', {
                    modules: [Autoplay, EffectFade],
                    observer: true,
                    observeParents: true,
                    loop: true,
                    spaceBetween: 0,
                    effect: 'fade',
                    speed: 800,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false,
                    },
                });
                this.photoSwiper = new Swiper('.photoSwiper', {
                    modules: [Autoplay],
                    observer: true,
                    observeParents: true,
                    loop: true,
                    spaceBetween: 28,
                    direction: "vertical",
                    slidesPerView: 5,
                    speed: 800,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false,
                    },
                });
            // }
        }
    },

    computed: {
        ...mapState(paymentModule, ['paymentList'])
    },

    async mounted () {
        await this.fetchData();
        this.dataRefreshInterval = setInterval(this.fetchData, 10000);
        this.generateQRCode();

        this.$nextTick(() => {
            this.initSwiper();
        });
    },

    beforeUnmount() {
        if (this.updateInterval) clearInterval(this.updateInterval);
        if (this.dataRefreshInterval) clearInterval(this.dataRefreshInterval);
        if (this.commentSwiper) this.commentSwiper.destroy(true, true);
        if (this.photoSwiper) this.photoSwiper.destroy(true, true);
    },

    watch: {
        paymentList() {
            this.$nextTick(() => {
                // this.initSwiper();
                if (this.commentSwiper) {
                    this.commentSwiper.update();
                }
                if (this.photoSwiper) {
                    this.photoSwiper.update();
                }
            });
        }
    }
}
</script>
<style lang="">

</style>